/*****************************************************************************
* This file is used in all pages and include all custom js code.
*
****************************************************************************/
window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
this.constructors = {};
this.instances = [];

$(document)
.on('shopify:section:load', this._onSectionLoad.bind(this))
.on('shopify:section:unload', this._onSectionUnload.bind(this))
.on('shopify:section:select', this._onSelect.bind(this))
.on('shopify:section:deselect', this._onDeselect.bind(this))
.on('shopify:block:select', this._onBlockSelect.bind(this))
.on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
_createInstance: function(container, constructor) {
var $container = $(container);
var id = $container.attr('data-section-id');
var type = $container.attr('data-section-type');

constructor = constructor || this.constructors[type];

if (_.isUndefined(constructor)) {
return;
}

var instance = _.assignIn(new constructor(container), {
id: id,
type: type,
container: container
});

this.instances.push(instance);
},

_onSectionLoad: function(evt) {
var container = $('[data-section-id]', evt.target)[0];
if (container) {
this._createInstance(container);
}
},

_onSectionUnload: function(evt) {
this.instances = _.filter(this.instances, function(instance) {
var isEventInstance = (instance.id === evt.detail.sectionId);

if (isEventInstance) {
if (_.isFunction(instance.onUnload)) {
instance.onUnload(evt);
}
}

return !isEventInstance;
});
},

_onSelect: function(evt) {
// eslint-disable-next-line no-shadow
var instance = _.find(this.instances, function(instance) {
return instance.id === evt.detail.sectionId;
});

if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
instance.onSelect(evt);
}
},

_onDeselect: function(evt) {
// eslint-disable-next-line no-shadow
var instance = _.find(this.instances, function(instance) {
return instance.id === evt.detail.sectionId;
});

if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
instance.onDeselect(evt);
}
},

_onBlockSelect: function(evt) {
// eslint-disable-next-line no-shadow
var instance = _.find(this.instances, function(instance) {
return instance.id === evt.detail.sectionId;
});

if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
instance.onBlockSelect(evt);
}
},

_onBlockDeselect: function(evt) {
// eslint-disable-next-line no-shadow
var instance = _.find(this.instances, function(instance) {
return instance.id === evt.detail.sectionId;
});

if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
instance.onBlockDeselect(evt);
}
},

register: function(type, constructor) {
this.constructors[type] = constructor;

$('[data-section-type=' + type + ']').each(function(index, container) {
this._createInstance(container, constructor);
}.bind(this));
}
});

/* ================ MODULES ================ */
/*============================================================================
Money Format
- Shopify.format money is defined in option_selection.js.
If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
Shopify.formatMoney = function(cents, format) {
var value = '',
placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
formatString = (format || this.money_format);

if (typeof cents == 'string') {
cents = cents.replace('.','');
}

function defaultOption(opt, def) {
return (typeof opt == 'undefined' ? def : opt);
}

function formatWithDelimiters(number, precision, thousands, decimal) {
precision = defaultOption(precision, 2);
thousands = defaultOption(thousands, ',');
decimal   = defaultOption(decimal, '.');

if (isNaN(number) || number == null) {
return 0;
}

number = (number/100.0).toFixed(precision);

var parts   = number.split('.'),
dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
cents   = parts[1] ? (decimal + parts[1]) : '';

return dollars + cents;
}

switch(formatString.match(placeholderRegex)[1]) {
case 'amount':
value = formatWithDelimiters(cents, 2);
break;
case 'amount_no_decimals':
value = formatWithDelimiters(cents, 0);
break;
case 'amount_with_comma_separator':
value = formatWithDelimiters(cents, 2, '.', ',');
break;
case 'amount_no_decimals_with_comma_separator':
value = formatWithDelimiters(cents, 0, '.', ',');
break;
}

return formatString.replace(placeholderRegex, value);
};
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
timber.cache = {
// General
$window                  : $(window),
$html                    : $('html'),
$body                    : $('body'),

// Navigation
$navigation              : $('#AccessibleNav'),
$navBar                  : $('.nav-bar'),
$mobileSubNavToggle      : $('.mobile-nav__toggle'),
$header                  : $('.site-header'),

// Collection Pages
$changeView              : $('.change-view'),

// Product Page
$productImage            : $('#ProductPhotoImg'),
$thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

// Customer Pages
$recoverPasswordLink     : $('#RecoverPassword'),
$hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
$recoverPasswordForm     : $('#RecoverPasswordForm'),
$customerLoginForm       : $('#CustomerLoginForm'),
$passwordResetSuccess    : $('#ResetSuccess')
};
};

timber.init = function () {
timber.cacheSelectors();
timber.accessibleNav();
timber.openDrawerMenu();
timber.closeDrawerMenu();
timber.drawersInit();
timber.mobileNavToggle();
timber.productImageSwitch();
timber.collectionViews();
timber.loginForms();
};

timber.accessibleNav = function () {
var $nav = timber.cache.$navigation,
$allLinks = $nav.find('a'),
$topLevel = $nav.children('li').find('a'),
$parents = $nav.find('.site-nav--has-dropdown'),
$subMenuLinks = $nav.find('.site-nav__dropdown'),
activeClass = 'nav-hover',
focusClass = 'nav-focus';

// Mouseenter
$parents.on('mouseenter touchstart', function(evt) {
var $el = $(this);

if (!$el.hasClass(activeClass)) { console.log('reach');
var is_iPad = navigator.userAgent.match(/iPad/i) != null;
if(is_iPad){
$(this).find('a:first').removeAttr('href');
// evt.preventDefault();
}
}

showDropdown($el);
});

// Mouseout
$parents.on('mouseleave', function() {
hideDropdown($(this));
});

$subMenuLinks.on('touchstart', function(evt) {
// Prevent touchstart on body from firing instead of link
evt.stopImmediatePropagation();
});

$allLinks.focus(function() {
handleFocus($(this));
});

$allLinks.blur(function() {
removeFocus($topLevel);
});

$allLinks.click(function() {
timber.closeDrawerMenu();
});

// accessibleNav private methods
function handleFocus ($el) {
var $subMenu = $el.next('ul'),
hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
isSubItem = $('.site-nav__dropdown').has($el).length,
$newFocus = null;

// Add focus class for top level items, or keep menu shown
if (!isSubItem) {
removeFocus($topLevel);
addFocus($el);
} else {
$newFocus = $el.closest('.site-nav--has-dropdown').find('a');
addFocus($newFocus);
}
}

function showDropdown ($el) {
//     $el.addClass(activeClass);

setTimeout(function() {
timber.cache.$body.on('click', function() {
hideDropdown($el);
});
}, 250);
}

function fatDropdown ($el) {
$el.addClass(activeClass);

timber.cache.$body.on('click', function() {
hideDropdown($el);
});
}

function hideDropdown ($el) {
$el.removeClass(activeClass);
timber.cache.$body.off('touchstart');
}

function addFocus ($el) {
$el.addClass(focusClass);
}

function removeFocus ($el) {
$el.removeClass(focusClass);
}
};

timber.openDrawerMenu = function () {
var $mobileMenu = $('.nav-bar'),
$mobileMenuButton = $('#menu-opener'),
$body = $('body');
$mobileMenuButton.addClass('opened');
$mobileMenu.addClass('opened');
$body.addClass('opened-drawer');

// Make drawer a11y accessible
timber.cache.$navBar.attr('aria-hidden', 'false');

// Set focus on drawer
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if(!isIE11) {
timber.trapFocus({
$container: timber.cache.$navBar,
namespace: 'drawer_focus'
});
}

// Escape key closes menu
timber.cache.$html.on('keyup.drawerMenu', function(evt) {
if (evt.keyCode == 27) {
timber.closeDrawerMenu();
}
});
}

timber.closeDrawerMenu = function () {

var $mobileMenu = $('.nav-bar'),
$mobileMenuButton = $('#menu-opener'),
$body = $('body');

$mobileMenuButton.removeClass('opened');
$mobileMenu.removeClass('opened');
$body.removeClass('opened-drawer');

// Make drawer a11y unaccessible
timber.cache.$navBar.attr('aria-hidden', 'true');

// Remove focus on drawer
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if(!isIE11) {
timber.removeTrapFocus({
$container: timber.cache.$navBar,
namespace: 'drawer_focus'
});
}

timber.cache.$html.off('keyup.drawerMenu');
}

timber.drawersInit = function () {
timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
'onDrawerOpen': theme.settings.ajax_cart_enable
});
};

timber.mobileNavToggle = function () {
timber.cache.$mobileSubNavToggle.on('click', function() {
$(this).parent().toggleClass('mobile-nav--expanded');
});
};

/**
* Traps the focus in a particular container
*
* @param {object} options - Options to be used
* @param {jQuery} options.$container - Container to trap focus within
* @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
* @param {string} options.namespace - Namespace used for new focus event handler
*/
timber.trapFocus = function (options) {
var eventName = options.eventNamespace
? 'focusin.' + eventNamespace
: 'focusin';

if (!options.$elementToFocus) {
options.$elementToFocus = options.$container;
options.$container.attr('tabindex', '-1');
}

options.$elementToFocus.focus();

$(document).on(eventName, function (evt) {
if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
options.$container.focus();
}
});
};

/**
* Removes the trap of focus in a particular container
*
* @param {object} options - Options to be used
* @param {jQuery} options.$container - Container to trap focus within
* @param {string} options.namespace - Namespace used for new focus event handler
*/
timber.removeTrapFocus = function (options) {
var eventName = options.namespace
? 'focusin.' + options.namespace
: 'focusin';

if (options.$container && options.$container.length) {
options.$container.removeAttr('tabindex');
}

$(document).off(eventName);
};

timber.getHash = function () {
return window.location.hash;
};

timber.updateHash = function (hash) {
window.location.hash = '#' + hash;
$('#' + hash).attr('tabindex', -1).focus();
};

timber.productPage = function (options) {
var moneyFormat = options.money_format,
variant = options.variant,
selector = options.selector;

// Selectors
var $productImage = $('#ProductPhotoImg'),
$addToCart = $('#AddToCart'),
$productPrice = $('#ProductPrice'),
$comparePrice = $('#ComparePrice'),
$quantityElements = $('.quantity-selector, label + .js-qty'),
$addToCartText = $('#AddToCartText');

if (variant) {

// Update variant image, if one is set
if (variant.featured_image) {
var newImg = variant.featured_image,
el = $productImage[0];
Shopify.Image.switchImage(newImg, el, timber.switchImage);
}

// Select a valid variant if available
if (variant.available) {
// Available, enable the submit button, change text, show quantity elements
$addToCart.removeClass('disabled').prop('disabled', false);
$addToCartText.html(theme.strings.add_to_cart);
$quantityElements.show();
} else {
// Sold out, disable the submit button, change text, hide quantity elements
$addToCart.addClass('disabled').prop('disabled', true);
$addToCartText.html(theme.strings.sold_out);
$quantityElements.hide();
}

// Regardless of stock, update the product price
$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

// Also update and show the product's compare price if necessary
if (variant.compare_at_price > variant.price) {
$comparePrice
.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
.show();
} else {
$comparePrice.hide();
}

} else {
// The variant doesn't exist, disable submit button.
// This may be an error or notice that a specific variant is not available.
// To only show available variants, implement linked product options:
//   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
$addToCart.addClass('disabled').prop('disabled', true);
$addToCartText.html(theme.strings.unavailable);
$quantityElements.hide();
}
};

timber.productImageSwitch = function () {
if (timber.cache.$thumbImages.length) {
// Switch the main image with one of the thumbnails
// Note: this does not change the variant selected, just the image
timber.cache.$thumbImages.on('click', function(evt) {
evt.preventDefault();
var newImage = $(this).attr('href');
timber.switchImage(newImage, null, timber.cache.$productImage);
});
}
};

timber.switchImage = function (src, imgObject, el) {
// Make sure element is a jquery object
var $el = $(el);
$el.attr('src', src);
};

timber.collectionViews = function () {
if (timber.cache.$changeView.length) {
timber.cache.$changeView.on('click', function() {
var view = $(this).data('view'),
url = document.URL,
hasParams = url.indexOf('?') > -1;

if (hasParams) {
window.location = replaceUrlParam(url, 'view', view);
} else {
window.location = url + '?view=' + view;
}
});
}
};

timber.loginForms = function() {
function showRecoverPasswordForm() {
timber.cache.$recoverPasswordForm.show();
timber.cache.$customerLoginForm.hide();
}

function hideRecoverPasswordForm() {
timber.cache.$recoverPasswordForm.hide();
timber.cache.$customerLoginForm.show();
}

timber.cache.$recoverPasswordLink.on('click', function(evt) {
evt.preventDefault();
showRecoverPasswordForm();
});

timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
evt.preventDefault();
hideRecoverPasswordForm();
});

// Allow deep linking to recover password form
if (timber.getHash() == '#recover') {
showRecoverPasswordForm();
}
};

timber.resetPasswordSuccess = function() {
timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
Drawer modules
- Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
var Drawer = function (id, position, options) {
var defaults = {
close: '.js-drawer-close',
open: '.js-drawer-open-' + position,
openClass: 'js-drawer-open',
dirOpenClass: 'js-drawer-open-' + position
};

this.$nodes = {
parent: $('body, html'),
page: $('#PageContainer'),
moved: $('.is-moved-by-drawer')
};

this.config = $.extend(defaults, options);
this.position = position;

this.$drawer = $('#' + id);

if (!this.$drawer.length) {
return false;
}

this.drawerIsOpen = false;
this.init();
};

Drawer.prototype.init = function () {
$(this.config.open).on('click', $.proxy(this.open, this));
this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
};

Drawer.prototype.open = function (evt) {
// Keep track if drawer was opened from a click, or called by another function
var externalCall = false;

// Prevent following href if link is clicked
if (evt) {
evt.preventDefault();
} else {
externalCall = true;
}

// Without this, the drawer opens, the click event bubbles up to $nodes.page
// which closes the drawer.
if (evt && evt.stopPropagation) {
evt.stopPropagation();
// save the source of the click, we'll focus to this on close
this.$activeSource = $(evt.currentTarget);
}

if (this.drawerIsOpen && !externalCall) {
return this.close();
}

// Add is-transitioning class to moved elements on open so drawer can have
// transition for close animation
this.$nodes.moved.addClass('is-transitioning');
this.$drawer.prepareTransition();

this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
this.drawerIsOpen = true;

// Set focus on drawer
this.trapFocus(this.$drawer, 'drawer_focus');

// Run function when draw opens if set
if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
if (!externalCall) {
this.config.onDrawerOpen();
}
}

if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
this.$activeSource.attr('aria-expanded', 'true');
}

// Lock scrolling on mobile
this.$nodes.page.on('touchmove.drawer', function () {
return false;
});

this.$nodes.page.on('click.drawer', $.proxy(function () {
this.close();
return false;
}, this));
};

Drawer.prototype.close = function () {
if (!this.drawerIsOpen) { // don't close a closed drawer
return;
}

// deselect any focused form elements
$(document.activeElement).trigger('blur');

// Ensure closing transition is applied to moved elements, like the nav
this.$nodes.moved.prepareTransition({ disableExisting: true });
this.$drawer.prepareTransition({ disableExisting: true });

this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

this.drawerIsOpen = false;

// Remove focus on drawer
this.removeTrapFocus(this.$drawer, 'drawer_focus');

this.$nodes.page.off('.drawer');
};

Drawer.prototype.trapFocus = function ($container, eventNamespace) {
var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

$container.attr('tabindex', '-1');

$container.focus();

$(document).on(eventName, function (evt) {
if ($container[0] !== evt.target && !$container.has(evt.target).length) {
$container.focus();
}
});
};

Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

$container.removeAttr('tabindex');
$(document).off(eventName);
};

return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);
window.theme = window.theme || {};

theme.Header = (function() {

var cache = {};

function cacheSelectors() {
cache = {
$html: $('html'),
$body: $('body'),
$wrapper: $('.wrapper'),
$sidebar: $('#sidebar'),
$logo: $('#logo'),
$meta: $('#meta'),
$siteHeader: $('.site-header'),
$siteHeaderSticky: $('.site-header:last-of-type') || null,
$menu: $('#menu'),
$nav: $('#AccessibleNav'),
$siteLogo: $('.site-header__logo'),
$mobileMenu: $('.nav-bar'),
$mobileMenuButton: $('#menu-opener'),
$responsiveMenu: $('#meta').find('.responsive-menu'),
$responsiveClose: $('.responsive-close'),
$options: $('#options'),
$footer: $('#footer'),
$content: $('#content'),
touchM: "ontouchstart" in window,
iOS: /(iPad|iPhone|iPod)/g.test(navigator.userAgent),
navWidth: 130,
logoWidth: 130
};
}

function init() {
cacheSelectors();
if (cache.touchM) {
cache.$body.addClass('touch');
} else {
cache.$body.addClass('no-touch');
}

if ($('header').hasClass('is-dark')) {
$('#PageContainer').addClass('is-dark');
$('#PageContainer').removeClass('is-light');
} else if ($('header').hasClass('is-light')) {
$('#PageContainer').addClass('is-light');
$('#PageContainer').removeClass('is-dark');
}

cache.$footer.removeClass('loading');

/* Enable fit vid & custom solution for posts videos */

$('p[style="text-align: center;"] img, p[style="text-align: center;"] iframe').each(function() {
$(this).parent().addClass('centered-media');
});

$('.main-content').fitVids();

menuStyleCheck();
//stickyHeader();

if ($('.link-list').length > 0) {
$('.link-list').clone().appendTo($('.nav-bar'));
}

menuDrawerButtons();
dropDownMenus();


}

/* Function that decides whether to show a hamburger icon or all the links */
function fitNav() { //console.log('hii'+ parseInt(cache.$wrapper.width(),10) +" > "+ parseInt(cache.navWidth,10) + " > //"+parseInt(cache.logoWidth,10));
 if ($(window).width() < 700){
  if (parseInt((cache.$wrapper.width()),10) < parseInt((cache.navWidth + cache.logoWidth - 259),10) && cache.$siteHeader.hasClass('site-header--classic')) { //console.log(cache.$wrapper.width()+" < "+(cache.navWidth + cache.logoWidth-259));
cache.$mobileMenu.removeClass('animate');
cache.$siteHeader.removeClass('site-header--classic');
cache.$siteHeader.addClass('site-header--drawer mobile sticky');
$('.desktop-menu-level').css('display', 'none');
$('.mobile-menu-level').css('display', 'block');
$('.main-content').addClass('mobile');
cache.$siteHeaderSticky.css('display', 'none');
cache.$logo.attr('src','//cdn.shopify.com/s/files/1/0505/5089/8861/t/46/assets/logo_large_white.png?v=99778763129091868051666792816');
cache.$siteHeader
.find('.btn__buy a')
.removeClass('btn--small btn--dark')
.addClass('btn--regular btn--light');
setTimeout(function() {
cache.$mobileMenu.addClass('animate');
}, 200);
// Make drawer a11y unaccessible
timber.cache.$navBar.attr('aria-hidden', 'true');
}
else if (parseInt((cache.$wrapper.width()),10) > parseInt((cache.navWidth + cache.logoWidth),10) && cache.$siteHeader.hasClass('site-header--drawer')) {
timber.closeDrawerMenu();  //console.log(cache.$wrapper.width() +" > "+ cache.navWidth + cache.logoWidth);
cache.$siteHeader.addClass('site-header--classic');
cache.$siteHeader.removeClass('site-header--drawer mobile sticky');
$('.desktop-menu-level').css('display', 'block');

$('.mobile-menu-level').css('display', 'none');
$('.main-content').removeClass('mobile');
cache.$siteHeaderSticky.css('display', 'block');
cache.$logo.attr('src','//cdn.shopify.com/s/files/1/0505/5089/8861/t/46/assets/logo_large.png?v=70619410606568897791666792810');
cache.$siteHeader
.find('.btn__buy a')
.addClass('btn--small btn--dark')
.removeClass('btn--regular btn--light');
cache.$mobileMenu.css('height', '100%');
// Make drawer a11y accessible
timber.cache.$navBar.attr('aria-hidden', 'false');
}
if (parseInt(cache.$wrapper.width(),10) < parseInt(cache.navWidth + cache.logoWidth -259,10)) {
cache.$mobileMenu.css('height', $(window).height());
}
cache.$siteLogo.css('opacity', '1');
cache.$nav.css('opacity', '0');
}
}
function menuStyleCheck() {
if (cache.$siteHeader.hasClass('site-header--classic')) {
cache.$siteHeader = $('.site-header:not(.created-by-js)');
timber.cache.$window.on('load', function() {
cache.logoWidth = cache.$siteLogo.width() || 0;
cache.$nav.children('li').each(function() {
cache.navWidth += $(this).outerWidth(true);
});
cache.navWidth = 600; // Added because of new header    
// Make drawer a11y accessible
timber.cache.$navBar.attr('aria-hidden', 'false');
fitNav();
timber.cache.$window.on('resize', $.debounce(250, fitNav));

})
};
}


/*function stickyHeader () {

if (cache.$siteHeader.hasClass('site-header--classic')) {

$('.site-header').after(cache.$siteHeader.clone());
cache.$siteHeaderSticky = $('.site-header:last-of-type');
cache.$siteHeaderSticky.addClass('sticky created-by-js').attr('aria-hidden', true).find('a').attr('tabIndex', -1);

setTimeout(function(){
cache.$siteHeaderSticky.addClass('animate');
}, 500)

$(window).on('optimizedScroll', function(){
if ( $(window).scrollTop() > 300 && !cache.$siteHeaderSticky.hasClass('active') ) {
cache.$siteHeaderSticky.addClass('active');
} else if ( $(window).scrollTop() < 300 && cache.$siteHeaderSticky.hasClass('active') ) {
cache.$siteHeaderSticky.removeClass('active');
}
});

}

}*/

function menuDrawerButtons (){

cache.$mobileMenuButton.on('click', function(e) {
if ($(this).hasClass('opened')) {
timber.closeDrawerMenu()
$('.mobile-nav-head').css('position', 'absolute');

} else {
timber.openDrawerMenu();
$('.mobile-nav-head').css('position', 'fixed');
}
e.preventDefault();
});
$('#menu-closer').on('click', function(e) {
$('.nav-bar').removeClass('opened');
timber.closeDrawerMenu();
e.preventDefault();
});

setTimeout(function() {
cache.$mobileMenu.addClass('animate');
}, 500);
}


function dropDownMenus() {
$('li.site-nav--has-dropdown').each(function() {
var count = 1;
$(this).on('click', function(e) {
var addh =  $('.openede ul').height();
var licount = $('.openede ul li').length;
var offsetLi = $('.openede').index('li');
if ($(this).hasClass('openede')) {
$('.mobile-menu-level.site-nav').css('height', 'auto');
$('li.site-nav--has-dropdown.openede .arrow-dropdown').removeClass('fa-angle-up');
$('li.site-nav--has-dropdown.openede .arrow-dropdown').addClass('fa-angle-down');
dropMenu($(this), 'out');
} else {
dropMenu($(this), 'in');
$('li.site-nav--has-dropdown').removeClass('current-open');
$(this).addClass('current-open');
$('.current-open .arrow-dropdown:first').addClass('fa-angle-up').removeClass('fa-angle-down');
$('.mobile-menu-level.site-nav').css('height', '150vh'); //console.log('hii110vh');
if($('.main-block-nav.expandede').length){
var elementOffset = $('.main-block-nav.expandede').offset().top,
i = $(this).offset(),
t = i.top - 90;
var fixoff = $( ".menu-slide-section li" ).first().offset().top;
r = t - elementOffset;
console.log($(this).offset().top - $('.menu-btns-nav').offset().top);
}
$('.mobil-menu-item.expand').animate({
scrollTop: $(this).offset().top - $('.menu-btns-nav').offset().top
}, 250);
}
});
/*** Added new condition for device checking - 12Sep2020 */
if ($(window).width() > 940) {
var is_iPad = navigator.userAgent.match(/iPad/i) != null;
if(!is_iPad){
$(this).on('mouseenter', function(e) {
dropMenu($(this), 'in');
//$('.cera-section.cera-content').css('opacity','0');
//e.preventDefault();
}).on('mouseleave', function(e) {
dropMenu($(this), 'out');
setTimeout(function(){
//$('.cera-section.cera-content').css('opacity','1');
}, 180);
//e.preventDefault();
});
}
}

$(this).children('.site-nav__dropdown')
.css({
'display' : 'block',
'opacity' : '1'
});
var maxW = 0;
$(this).find('li').each(function() {
$(this).css('position', 'fixed');
if ($(this).width() > maxW) {
maxW = $(this).width();
}
$(this).css('position', 'relative');
});
maxW += 51;
$(this).children('.site-nav__dropdown:not(".mega-menu")').css({
width: maxW,
marginLeft: -maxW/2,
display: 'none'
});
$(this).children('.site-nav__dropdown.mega-menu').css({
display: 'none',
left:0
});
});


}

function dropMenu($menu, dir) {
if (dir == 'out') {
$menu.removeClass('openede');

$menu.children('.site-nav__dropdown').stop().slideUp(10);
} else {
if(!($menu.parents('li').hasClass('openede'))){
$('li.site-nav--has-dropdown').removeClass('openede');
$('.site-nav__dropdown ').css('display', 'none');
$('.arrow-dropdown').removeClass('fa-angle-up');
$('.current-open .arrow-dropdown:first').addClass('fa-angle-down');
}
if($('li.child-li-dropdown').hasClass('openede')){
$('li.child-li-dropdown').removeClass('openede');
$('li.child-li-dropdown .site-nav__dropdown ').css('display', 'none');
$('li.child-li-dropdown .arrow-dropdown').removeClass('fa-angle-up');
$('li.child-li-dropdown.current-open .arrow-dropdown').addClass('fa-angle-down');
}
$menu.addClass('openede');

$menu.children('.site-nav__dropdown').stop().slideDown(10).position();
calcMenuPosition($menu.children('.mega-menu'), $menu);
}
}

function calcMenuPosition(menu, menuu)
{
if(menu.length >0)
{
menu.css('width','110vw');
if(menu.offset().left!=0)
{
menu.css('left',-menuu.offset().left);
}
}
}

function onSelect() {
if (cache.$siteHeader.hasClass('site-header--classic')) {
cache.logoWidth = cache.$siteLogo.width() || 0;
cache.$nav.children('li').each(function() {
cache.navWidth += $(this).outerWidth(true);
});
cache.navWidth = 600; // Added because of new header    
// Make drawer a11y accessible
timber.cache.$navBar.attr('aria-hidden', 'false');
fitNav();
timber.cache.$window.on('resize', $.debounce(250, fitNav));
};
}


function unload() {
if (cache.$body.hasClass('opened-drawer')){
cache.$body.removeClass('opened-drawer');
}
}

return {
init: init,
unload: unload,
onSelect: onSelect,
fitNav:fitNav
};

})();
window.theme = window.theme || {};

theme.Slideshow = (function(el) {

this.cache = {
$slider: $(el),
sliderArgs: {
animation: 'slide',
animationSpeed: 300,
slideshow: false,
slideshowSpeed: 5000,
directionNav: true,
controlNav: 'thumbnails',
keyboard: true,
prevText: $.themeAssets.arrow_left,
nextText: $.themeAssets.arrow_right,
smoothHeight: true,
before: function(slider) {
$(slider).resize();
$(slider).find('.slide').not('.flex-active-slide').removeClass('slide-hide');
},
after: function(slider) {
$(slider).find('.slide').not('.flex-active-slide').addClass('slide-hide');
$(slider).find('video').each(function (i, el) {
el.pause();
});
},
start: function(slider) {
$('body').removeClass('loading');
$(slider).find('.slide').not('.flex-active-slide').addClass('slide-hide');
if ($(slider).find('.slide').not('.clone').length === 1) {
$(slider).find('.flex-direction-nav').remove();
}
$(window).trigger('resize');
slider.addClass('loaded');
if ($('#slider').data('loaded-index') != undefined) {
$('#slider').flexslider($('#slider').data('loaded-index'));
}
if(typeof VideoPreloader !== 'undefined') {
VideoPreloader.transform($(slider).find('.js-video'));
}
},
video: $(el).find('video, .js-video').length > 0
}
}

if (this.cache.$slider.find('li').length === 1) {
this.cache.sliderArgs.touch = false;
}

return this.cache.$slider.flexslider(this.cache.sliderArgs);

});

/* ================ SECTIONS ================ */
window.theme = window.theme || {};
$(timber.init);
theme.HeaderSection = (function() {

function Header() {

theme.Header.init();

}

Header.prototype = _.assignIn({}, Header.prototype, {
onUnload: function() {
theme.Header.unload();
},
onSelect: function(){
theme.Header.onSelect();
}
});


return Header;
})();
/* eslint-disable no-new */
theme.Product = (function() {
var defaults = {
selectors: {
addToCart: '#AddToCart',
productPrice: '#ProductPrice',
comparePrice: '#ComparePrice',
addToCartText: '#AddToCartText',
quantityElements: '.quantity-selector',
optionSelector: 'productSelect',
}
};

function Product(container) {
var $container = this.$container = $(container);
var sectionId = $container.attr('data-section-id');

this.settings = $.extend({}, defaults, {
sectionId: sectionId,
enableHistoryState: true,
selectors: {
originalSelectorId: 'productSelect-' + sectionId,
addToCart: '#AddToCart-' + sectionId,
productPrice: '#ProductPrice-' + sectionId,
comparePrice: '#ComparePrice-' + sectionId,
addToCartText: '#AddToCartText-' + sectionId,
quantityElements: '#quantity-selector-' + sectionId,
slider: '#slider-' + sectionId,
selectorWrapper: '.selector-wrapper' + sectionId
}
});

// disable history state if on homepage
if($('body').hasClass('template-index')) {
this.settings.enableHistoryState = false;
}

// Stop parsing if we don't have the product json script tag when loading
// section in the Theme Editor
if (!$('#ProductJson-' + sectionId).html()) {
this.addQuantityButtons();
return;
}

this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
this.init();

// Pre-loading product images to avoid a lag when a thumbnail is clicked, or
// when a variant is selected that has a variant image
Shopify.Image.preload(this.productSingleObject.images);
}

Product.prototype = _.assignIn({}, Product.prototype, {
init: function() {
this.stringOverrides();
this.initProductVariant();
this.initSliderImages();
this.addQuantityButtons();
theme.customSelectorArrow(this.$container);

$('.image-popup', this.$container).magnificPopup({
type: 'image',
modal:true,
closeBtnInside:false,
gallery: {
enabled: true,
tCounter: ''
},
callbacks: {
open: function() {
console.log('Popup is opened');
//Clone thumbnails
var thumbs =  $('.flex-control-thumbs').clone().children();

var thumbContainer = $('<ul class="flex-control-nav flex-control-thumbs lightbox-thumbs"/>');

thumbs = thumbs.filter(function(i, el) {
var img = $(el).find('img');
if (img.attr('src').indexOf('/play.png') !== -1) {
return false;
}
return true;
});

thumbContainer.append(thumbs);

$('.mfp-content').prepend(thumbContainer);
thumbs.children().each(function( index, element ) {
$(element).attr('data-index',index+1);
$(element).off('click');
$(element).click(function(){
$.magnificPopup.instance.goTo($(this).data('index'));
});
});
},
buildControls: function() {
// re-appends controls inside the main container
if(this.arrowLeft && this.arrowRight) {
this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
}
}
},
mainClass: 'mfp-fade'
});
},

onUnload: function() {
delete theme.slideshows[this.settings.selectors.slider];
},

stringOverrides: function() {
// Override defaults in theme.strings with potential
// template overrides

theme.productStrings = theme.productStrings || {};
$.extend(theme.strings, theme.productStrings);
},

addQuantityButtons: function(){
if ($(this.settings.selectors.quantityElements).children('input#Quantity').length > 0) {

$(this.settings.selectors.quantityElements).children('input#Quantity')
.after(
'<div class="input-holder plus"><button type="button" value="" class="plus" aria-label="'+ theme.strings.increase_quantity + '">' +
  $.themeAssets.plus +
  '</button></div>')
.before(
'<div class="input-holder minus"><button type="button" value="" class="minus" aria-label="' + theme.strings.reduce_quantity + '">' +
  $.themeAssets.minus +
  '</button></div>')
};

},

initProductVariant: function() {
// this.productSingleObject is a global JSON object defined in theme.liquid
if (!this.productSingleObject) {
return;
}

var self = this;
this.optionSelector = new Shopify.OptionSelectors(self.settings.selectors.originalSelectorId, {
selectorClass: self.settings.selectors.optionSelectorClass,
product: self.productSingleObject,
onVariantSelected: self.productVariantCallback,
enableHistoryState: self.settings.enableHistoryState,
settings: self.settings
});

// Clean up variant labels if the Shopify-defined
// defaults are the only ones left
this.simplifyVariantLabels(this.productSingleObject);
},

simplifyVariantLabels: function(productObject) {
// Hide variant dropdown if only one exists and title contains 'Default'
if (productObject.variants.length && productObject.variants[0].title.indexOf('Default') >= 0) {
$('.selector-wrapper').hide();
}
},


initSliderImages: function(){
var slideshow = this.settings.selectors.slider;
$(slideshow).imagesLoaded().done( function( instance ) {
theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
});

},

// **WARNING** This function actually inherits `this` from `this.optionSelector` not
// from `product` when passed in as a callback for `option_selection.js`
productVariantCallback: function(variant) {

if (variant) {
// Update variant image, if one is set
if (variant.featured_image) {
var $slider = $(this.settings.selectors.slider);
var newImg = $slider.find('.slide[data-variant-img="' + variant.featured_image.id + '"]');
if (newImg.length > 0) {
if ($slider.hasClass('loaded')) {
$slider.flexslider(newImg.data('index'));
} else {
$slider.data('loaded-index', newImg.data('index'));
}
}
}

// Update the product price
$(this.settings.selectors.productPrice).html(Shopify.formatMoney(variant.price, theme.settings.moneyFormat));

// Update and show the product's compare price if necessary
if (variant.compare_at_price > variant.price) {
$(this.settings.selectors.comparePrice)
.html(Shopify.formatMoney(variant.compare_at_price, theme.settings.moneyFormat)).show();
} else {
$(this.settings.selectors.comparePrice).hide();
}

// Select a valid variant if available
if (variant.available) {
// We have a valid product variant, so enable the submit button
$(this.settings.selectors.addToCart).removeClass('btn--disabled').prop('disabled', false);
$(this.settings.selectors.addToCartText).text(theme.strings.add_to_cart);
$(this.settings.selectors.quantityElements).removeClass('hidden');
} else {
// Variant is sold out, disable the submit button and change the text
$(this.settings.selectors.addToCart).addClass('btn--disabled').prop('disabled', true);
$(this.settings.selectors.addToCartText).text(theme.strings.sold_out);
$(this.settings.selectors.quantityElements).addClass('hidden');
}
} else {
// The variant doesn't exist, disable submit button and change the text.
// This may be an error or notice that a specific variant is not available.
$(this.settings.selectors.addToCart).addClass('btn--disabled').prop('disabled', true);
$(this.settings.selectors.addToCartText).text(theme.strings.unavailable);
$(this.settings.selectors.quantityElements).addClass('hidden');
}
}

});

return Product;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
function SlideshowSection(container) {
var $container = this.$container = $(container);
var id = $container.attr('data-section-id');
var slideshow = this.slideshow = '#flexslider--' + id;
theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
}

return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
onUnload: function() {
delete theme.slideshows[this.slideshow];
},

onBlockSelect: function(evt) {
var $slideshow = $(this.slideshow);
// Ignore the cloned version
var $slide = $('#slide-' + evt.detail.blockId + ':not(.clone)');
var slideIndex = $slide.data('flexslider-index');
var $slideImg = $slide.find('img') || $slide.find('svg');

$slide.imagesLoaded($slideImg,function(){
$slideshow.flexslider(slideIndex);
$slideshow.flexslider("pause");

});

},

onBlockDeselect: function() {
// Resume autoplay
$(this.slideshow).flexslider('play');
}
});
window.theme = window.theme || {};

theme.Kickstarter = (function() {

function Kickstarter() {

theme.crowdCampaign();

}

Kickstarter.prototype = _.assignIn({}, Kickstarter.prototype, {
init: function() {
theme.crowdCampaign();
},
onSelect: function(){
theme.crowdCampaign();
}
});

return Kickstarter;
})();
window.theme = window.theme || {};

theme.FAQs = (function() {

function FAQs(container) {
var $container = this.$container = $(container);
var sectionId = $container.attr('data-section-id');

this.faqSelector = '.jumpstart-accordion-' + this.sectionId;

theme.accordionFAQs(this.$container);

this.$blocks = $('.section', $container);
this.$opened = $('.opened', $container);
}

FAQs.prototype = _.assignIn({}, FAQs.prototype, {
init: function() {

this.$opened.find('.content').slidedown(0);

this.$blocks.find('.title').prepend($.themeAssets.plus + $.themeAssets.minus);

this.$blocks.on('click', function(evt) {
var blockId = $(evt.target).attr('data-block-id');
this.focusFAQ(blockId);
});
},
focusFAQ: function(blockId, isEditorEvent) {
$accordionItem = $('.section-' + blockId);
if ($accordionItem.hasClass('opened') && !isEditorEvent) {
$accordionItem.removeClass('opened');
$accordionItem.children('div').stop().slideUp(300);
}
else {
$accordionItem.addClass('opened');
$accordionItem.children('div').stop().slideDown(300);
this.$blocks.not($accordionItem).removeClass('opened').children('div').stop().slideUp(300);
}
},
onBlockSelect: function(evt){
this.focusFAQ(evt.detail.blockId, true);

},
onload: function(){
theme.accordionFAQs(this.$container);

}
});

return FAQs;
})();

/* ================ TEMPLATES ================ */
window.theme = window.theme || {};

theme.Collection = (function() {

function Collection() {

theme.collectionGridMasonry();

}

Collection.prototype = _.assignIn({}, Collection.prototype, {
init: function() {
theme.collectionGridMasonry();
},
onSelect: function(){
theme.collectionGridMasonry();
}
});

return Collection;
})();


theme.cacheSelectors = (function(){
theme.cache = {
$html : $('html'),
$body : $('body'),
$wrapper : $('.wrapper'),
$sidebar : $('#sidebar'),
$logo : $('#logo'),
$meta : $('#meta'),
$siteHeader : $('.site-header'),
$menu : $('#menu'),
$nav : $('#AccessibleNav'),
$siteLogo : $('.site-header__logo'),
$mobileMenu : $('.nav-bar'),
$mobileMenuButton : $('#menu-opener'),
$responsiveMenu : $('#meta').find('.responsive-menu'),
$responsiveClose : $('.responsive-close'),
$options : $('#options'),
$footer : $('#footer'),
$content : $('#content'),
touchM : "ontouchstart" in window,
iOS : /(iPad|iPhone|iPod)/g.test(navigator.userAgent),
navWidth : 130,
logoWidth : 130

}

});

theme.customSelectorArrow = (function(el) {
var scope = el || document;
$('select', $(scope)).each(function() {
$(this).wrap('<div class="jumpstart-selector"></div>');
$(this).parent().attr('style', $(this).attr('style'));
$(this).parent().append('<span class="arrow">' + $.themeAssets.arrow_down + '</span>');
});
});

theme.collectionGridMasonry = (function() {
if ( (typeof $.fn.packery !== 'undefined') && ($('.collection-list').length > 0) ) {
$('.collection-list').imagesLoaded(function() {
$('.collection-list').packery({
itemSelector: '.product',
transitionDuration: 0
});
});
}
});

theme.parallaxBg = (function() {
if ( $('.parallax-bg').length > 0 || $('#section-a').length > 0 ) {
if ($('#section-a').length > 0) {
var $prlxBg = $('#section-a span.prlx-bg'),
$prlxTxt = $('#section-a .wrapper').addClass('prlx-txt');
$prlxBg.parent().addClass('parallax-bg');
} else {
var $prlxBg = $('.prlx-bg'),
$prlxTxt = $('.prlx-txt');
}
$(window).on('optimizedScroll', function(){
if ($(window).scrollTop() < $prlxBg.height()) {
$prlxBg.css('transform', 'translate3d(0px, ' + ($(window).scrollTop()/4) + 'px, 0px)');
$prlxTxt.css('transform', 'translate3d(0px, ' + ($(window).scrollTop()/8) + 'px, 0px)');
}
});

}
});

theme.quantityButtons = (function() {
if ($('input#Quantity').length > 0) {

$(document).on( 'click', '.plus, .minus', function() {

var $qty = $(this).siblings('#Quantity'),
currentVal = parseFloat($qty.val()),
max = parseFloat($qty.attr('max')),
min = parseFloat($qty.attr('min')),
step = $qty.attr('step');

if ( ! currentVal || currentVal === '' || currentVal === 'NaN' ) currentVal = 0;
if ( max === '' || max === 'NaN' ) max = '';
if ( min === '' || min === 'NaN' ) min = 0;
if ( step === 'any' || step === '' || step === undefined || parseFloat( step ) === 'NaN' ) step = 1;

if ($(this).is('.plus')) {
if ( max && ( max == currentVal || currentVal > max ) ) {
$qty.val(max);
} else {
$qty.val(currentVal + parseFloat( step ));
}
}
else {
if ( min && ( min == currentVal || currentVal < min ) ) {
$qty.val( min );
} else if ( currentVal > 0 ) {
$qty.val( currentVal - parseFloat( step ) );
}
}
$qty.trigger( 'change' );
});

}
});

theme.passwordFooter = (function(){
if ($('.template-password').length > 0) {
var $pageContainer = $('#PageContainer'),
$passwordFooter = $('#password-footer');
$(window).on('optimizedResize', function() {
if ($(window).height() < $pageContainer.height()) {
$passwordFooter.removeClass('full');
} else {
$passwordFooter.addClass('full');
}
}).trigger('resize');
}
});

theme.infiniteBlog = (function(){
var $infiniteLink = $('#infinite-link'),
$infiniteURL = $infiniteLink.children('a'),
$blogList = $('.blog-list');

if ($infiniteLink.length > 0) {
$infiniteURL.on('click', function(e) {
$infiniteURL.addClass('btn--disabled').text('Loading ...');
var href = $(this).attr('href');
$.ajax({
url: href,
success: function(data) {
var $data = $(data),
$posts = $data.find('a.article'),
$infinite = $data.find('#infinite-link');
$posts.imagesLoaded(function() {
$posts.css('display', 'none');
$blogList.append($posts);
$posts.slideDown(300);
if ($infinite.length > 0) {
$infiniteURL.removeClass('btn--disabled')
.text('More posts')
.prop('href', $infinite.children('a').prop('href'));
} else {
$infiniteURL.text('All posts loaded');
}
});
}
});
e.preventDefault();
});
}
});

theme.homeGallery = (function(){

if ($('.home-gallery').length > 0) {
$('.home-gallery').imagesLoaded(function() {
$('.home-gallery').find('.item').each(function() {
var $img = $(this).find('img');
if ( $img[0].naturalWidth <= $img[0].naturalHeight ) {
$(this).addClass('one-quarter medium-down--one-half');
} else {
$(this).addClass('one-half medium-down--one-whole');
}
});
$('.home-gallery').find('.packery-container').packery({
itemSelector: '.grid__item',
gutter: 0,
percentPosition: true,
transitionDuration: 0
});
$('.home-gallery').addClass('init');
$('.home-gallery').find('.packery-container').packery();
});
}

});

theme.iframePopUp = (function(){
$('.video-overlay').magnificPopup({
type: 'iframe',
mainClass: 'mfp-fade'
});
});

theme.accordionFAQs = (function(el){
var scope = el || document;

if ($('.jumpstart-accordion', $(scope)).length > 0) {
$('.jumpstart-accordion', $(scope)).each(function() {
var $sections = $(this).children('div');
var $opened = $sections.filter('.opened');
$opened.children('div').slideDown(0);
$(this)
.children('div')
.children('h3')
.prepend($.themeAssets.plus + $.themeAssets.minus)
.click(function() {
console.log('onclick fired');
var $this = $(this).parent();
if ($this.hasClass('opened')) {
console.log('has opened class')
$this.removeClass('opened');
$this.children('div').stop().slideUp(300);
}
else {
$this.addClass('opened');
$this.children('div').stop().slideDown(300);
$sections.not($this).removeClass('opened').children('div').stop().slideUp(300);
}
}
);
});
}
});

theme.crowdCampaign = (function(){
if ($('.home-kickstarter').length > 0) {

// PIE

$('.kickstarter__graphic.pie').html('<canvas id="kickstarter__pie--help" width="110" height="110"></canvas><canvas id="kickstarter__pie" width="110" height="110"></canvas>');

var progress = 0,
pieI = null,
pieValue = Math.min( parseInt($('.kickstarter__graphic').data('value')) / 100, 1 ),
pieColor = $('.kickstarter__graphic').data('color'),
pieCanvas = document.getElementById('kickstarter__pie'),
context = pieCanvas.getContext('2d'),
centerX = pieCanvas.width / 2,
centerY = pieCanvas.height / 2,
radius = 45,
progress = 0;

context.lineWidth = 15;
context.strokeStyle = pieColor;
context.lineCap = 'round';

pieI = setInterval(function() {
progress = progress + 0.0025;
context.clearRect(0, 0, pieCanvas.width, pieCanvas.height);
context.beginPath();
context.arc(centerX, centerY, radius, 0, (2*progress) * Math.PI, false);
context.stroke();
if (progress >= pieValue) {
clearInterval(pieI);
}
}, 5);

var pieCanvasHelp = document.getElementById('kickstarter__pie--help'),
contextHelp = pieCanvasHelp.getContext('2d'),
centerXHelp = pieCanvasHelp.width / 2,
centerYHelp = pieCanvasHelp.height / 2,
radiusHelp = 45;

contextHelp.lineWidth = 15;
contextHelp.strokeStyle = '#e9e9e9';
contextHelp.lineCap = 'round';
contextHelp.beginPath();
contextHelp.arc(centerXHelp, centerYHelp, radiusHelp, 0, 2 * Math.PI, false);
contextHelp.stroke();

// BAR

var barValue = Math.min(parseInt($('.kickstarter__graphic.bar').data('value')), 100);
$('.kickstarter__graphic.bar').append('<div class="value"></div>');
$('.kickstarter__graphic.bar .value').css('width', barValue + '%');

}

});

theme.cerascreenCustom = (function(){
theme.Header.fitNav();
//Searchbuttons
  
$('.btn__search').click(function(){
var target = $(this).data('target');
$(target).toggleClass('open');
$(target).find('input').focus();
});
$('.search-close').click(function(e){
var target = $(this).data('target');
$(this).siblings('input').val('');
$(target).removeClass('open');
e.preventDefault();
});
});

$(document).ready(function() {
var sections = new theme.Sections();

sections.register('header-section', theme.HeaderSection);
sections.register('slideshow-section', theme.SlideshowSection);
sections.register('product', theme.Product);
sections.register('home-product', theme.Product);
sections.register('collection-template', theme.Collection);
sections.register('list-collection-template', theme.Collection);
sections.register('home-kickstarter', theme.Kickstarter);
sections.register('home-faq', theme.FAQs);


});


(function($) {

$(document).ready(function($){

"use strict";

/* Elements */

var $html = $('html'),
$body = $('body'),
$wrapper = $('.wrapper'),
$sidebar = $('#sidebar'),
$logo = $('#logo'),
$meta = $('#meta'),
$siteHeader = $('.site-header'),
$menu = $('#menu'),
$nav = $('#AccessibleNav'),
$siteLogo = $('.site-header__logo'),
$mobileMenu = $('.nav-bar'),
$mobileMenuButton = $('#menu-opener'),
$responsiveMenu = $meta.find('.responsive-menu'),
$responsiveClose = $('.responsive-close'),
$options = $('#options'),
$footer = $('#footer'),
$content = $('#content'),
touchM = "ontouchstart" in window,
iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent),
navWidth = 130,
logoWidth = 130;

});

})(jQuery);

theme.init = function() {
theme.cacheSelectors();
theme.parallaxBg();
theme.customSelectorArrow();
theme.quantityButtons();
theme.passwordFooter();
theme.infiniteBlog();
theme.homeGallery();
theme.iframePopUp();
theme.cerascreenCustom();

if (theme.cache.$body.hasClass('template-index')) {
if ( ($('.main-content').children('.index-sections').children('.shopify-section').length % 2) != 0 ) {
$('.social-footer').addClass('even');
}
}

};
$(theme.init);

(function($) {
// Video preloading based on connection type with browser/OS-fallback
window.VideoPreloader = window.VideoPreloader || (function() {
var preload = true, connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

if(typeof connection !== 'undefined') {
//The following code first uses the new navigator.connection object and as a fallback does a fuzzy user-agent detection
if(
(
typeof connection.type !== 'undefined' &&
!/ethernet|wifi|wimax/i.test(connection.type)
) ||
(
typeof connection.effectiveType !== 'undefined' &&
/slow-2g|2g|3g|4g/i.test(connection.effectiveType)
)
) {
preload = false;
}
} else if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent)) {
preload = false;
}

var transform = function($videos) {
$videos.each(function(_, video) {
var $video = $(video), src = $video.attr('data-src');
if(src) {
// its a bad hack, but we activate autoplay, so the first frame loads and then immediately pause the playback.
// https://stackoverflow.com/a/39231763/5794504
var $repl = $('<video src="'+src+'" width="100%" controls="controls" autoplay="autoplay" preload="'+((preload) ? 'auto' : 'none')+'" />');
$video.replaceWith($repl).remove();
$repl[0].pause();
if(!preload) {
// on the first play set preload to auto and then remove the event handler
var func = function() { $repl.attr('preload', 'auto').off('play', func); };
$repl.on('play', func);
}
}
});
}

return { transform: transform };
})();


$(document).on('ready shopify:section:load', function() {
var minHeight = 152,
lineHeight = 30,
keydown = function(e) {
$(e.target).css('height', Math.max(minHeight, (e.target.value.split("\n").length*lineHeight)+2));
};

// Blog comments
$('#CommentBody').css('overflow', 'hidden').each(function(_, el) {
throttle('keydown', 'optimizedKeydown', el);
}).on('optimizedKeydown', keydown);

// worst case scenario: polling, until a variable exists. very bad architecture in Shopify
if($('#shopify-product-reviews').length > 0) {
var interval = window.setInterval(function() {
var $tmp = $('.spr-form-review-body textarea');
if($tmp.length > 0) {
clearInterval(interval);
// Review form
$tmp.css('overflow', 'hidden').each(function(_, el) {
throttle('keydown', 'optimizedKeydown', el);
}).on('optimizedKeydown', keydown);
// Rewrite bogus functionality to rewrite h3 back to h2 - the brute force way
$('.spr-header-title').each(function(_, el) {
var $el = $(el);
$el.replaceWith(el.outerHTML.replace(/(<\/?h)2/, '$13'));
});
}
}, 1000);
}

var $cookieNotif = $('.cookie-notification'),
$cookieNotifBtn = $cookieNotif.find('.cookie-notification__button');
if(
$cookieNotif.length > 0 &&
Cookies &&
Cookies.get('cookie-notification') === undefined
) {
$cookieNotif.addClass('cookie-notification--show');
document.getElementsByTagName('body')[0].appendChild(document.getElementsByClassName('cookie-notification')[0]);

$cookieNotifBtn.click(function(e) {
e.preventDefault();
$cookieNotif.removeClass('cookie-notification--show');
Cookies.set('cookie-notification', 1);
});
}

// Do video preloading
VideoPreloader.transform($('.js-video').filter(function(_, video) {
// Filter out videos in a flexslider. They are handled seperately.
return $(video).parents('.flexslider').length === 0;
}));

// adding an h2-index for blog posts
var $article = $('.js-article-index')
,$h2s = $article.find('h2')
,$index = $('.article__index')
,$list = $index.find('.article__index-list')
,$handle = $index.find('.article__index-handle')
,$close = $index.find('.article__index-close')
,$measure = $('.article__newsletter')
,$window = $(window)
;

if ($h2s.length > 0 && $index.length > 0 && $list.length > 0 && $measure.length > 0) {
var anchors = [];
$h2s.each(function(_, h2) {
var $h2 = $(h2)
,title = $h2
.html()
.replace(/<.+?>|&.+?;/g, ' ')
.replace(/^\s+|\s+$/g, '')
,german = {
'ä': 'ae'
,'ö': 'oe'
,'ü': 'ue'
,'Ä': 'Ae'
,'Ö': 'Oe'
,'Ü': 'Ue'
,'ß': 'ss'
}
,id = title
.toLowerCase()
.replace(/[^A-Za-z0-9äöüÄÖÜß\s\-]+/g, '')
.replace(/\s+/g, '-')
.replace(/-{2,}/g, '-')
.split('')
.map(function(tmp) {
return german[tmp] || tmp;
})
.join('')
;
if(title != '' && id != '') {
anchors.push([title.replace(/\s{2,}/g, ' '), id]);
$h2.attr('id', id);
}
});
if (anchors.length > 0) {
var result = '';
anchors.forEach(function(anchor) {
result += '<li class="article__index-item">'
  +'<a class="article__index-link" href="#'+anchor[1]+'">'+anchor[0]+'</a>'
  +'</li>'
;
});
$list.html(result);
$index.addClass('article__index--show');

// we have to rebuilt the native anchor functionality, because the header is sticky and the h2 will be under it
$('.article__index-link').each(function(_, link) {
var $link = $(link);
$link.click(function(e) {
e.preventDefault();
var uuid = $link[0].href.replace(/^.*#/, '')
,$el = $('#'+uuid)
;
if($el.length > 0) {
$window.scrollTop($el[0].getBoundingClientRect().top+$window.scrollTop()-90);
$index.removeClass('article__index--flyout');
}
});
});
}

// sticky feature
throttle('scroll', 'optimizedScroll', window);
throttle('resize', 'optimizedResize', window);

function reCalculate() {
var scrollTop = $window.scrollTop()
,indexRect = $index[0].getBoundingClientRect()
,articleRect = $article[0].getBoundingClientRect()
,measureRect = $measure[0].getBoundingClientRect()
;
$index
.toggleClass('article__index--sticky', 50 > measureRect.bottom)
.css({
'left': measureRect.left
,'transform': 'translateY(-'+Math.max(0, indexRect.height-(articleRect.top+articleRect.height))+'px)'
,'width': measureRect.width
})
;
}
$window.on('optimizedScroll', reCalculate);
$window.on('optimizedResize', reCalculate);

// mobile handles and swipe gesture
function openFlyout(e, toggle) {
e.preventDefault();
$index.addClass('article__index--flyout');
}

function closeFlyout(e, toggle) {
e.preventDefault();
$index.removeClass('article__index--flyout');
}

function toggleFlyout(e, toggle) {
e.preventDefault();
$index.toggleClass('article__index--flyout');
}

$handle.click(toggleFlyout);
$close.click(closeFlyout);

// Hammer.js gestures
var mcClose = new Hammer.Manager($index[0], {});
mcClose.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_RIGHT }));
mcClose.on('swipe', function(e) { closeFlyout(e); });

var mcClose2 = new Hammer.Manager($list[0], {});
mcClose2.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_RIGHT }));
mcClose2.on('swipe', function(e) { closeFlyout(e); });

var mcOpen = new Hammer.Manager($handle[0], {});
mcOpen.add(new Hammer.Swipe());
mcOpen.on('swipe', function(e) {
if(e.offsetDirection === Hammer.DIRECTION_LEFT) {
openFlyout(e);
} else if(e.offsetDirection === Hammer.DIRECTION_RIGHT) {
closeFlyout(e);
}
});
}
});
})(jQuery);
$(document).ready(function() {
thumbnails = $('img[src*="/products/"]').not(':first');
if (thumbnails.length) {
thumbnails.bind('click', function() {
var arrImage = $(this).attr('src').split('?')[0].split('.');
var strExtention = arrImage.pop();
var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
if (typeof variantImages[strNewImage] !== 'undefined') {
productOptions.forEach(function (value, i) {
optionValue = variantImages[strNewImage]['option-'+i];
if (optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function() { return $(this).text().trim() === optionValue }).length) {
$('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
}
});
}
});
}
});

// accordian js
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
acc[i].onclick = function() {
this.classList.toggle("active");
var panel = this.nextElementSibling;
if (panel.style.maxHeight){
panel.style.maxHeight = null;
panel.classList.remove("active");
} else {
panel.style.maxHeight = panel.scrollHeight + "px";
panel.classList.add("active");
}
}
}
$(document).on('touchstart', function(e) {
if (!$(e.target).is('#menu-opener') && !$(event.target).closest(".nav-bar,nav").length) {
timber.closeDrawerMenu();
}
});


// js for new mobile menu
$(document).ready(function(){
$('.menu-btns-nav a').on('click', function(e){
var tagrtd = $(this).attr('data-menu-target');
var traatext = $(this).text();
if(tagrtd != ''){
$('#' + tagrtd).addClass("inn");
$('.expand-menu-name').text(traatext);
$('.mobil-menu-item').addClass('expand');
$('.main-block-nav').addClass('expandede');
}
});
$('.expn-nenu .fa-angle-left').on('click', function(e){
$('.menu-slide-section').removeClass("inn");
$('.mobil-menu-item').removeClass('expand');
$('.main-block-nav').removeClass('expandede');
$('.site-nav--has-dropdown').removeClass('openede');
$('.site-nav--has-dropdown').removeClass('current-open');
$('.arrow-dropdown').removeClass('fa-angle-up');
$('.arrow-dropdown').addClass('fa-angle-down');
$('.site-nav__dropdown').css('display','none');
});
$('#menu-closer').on('click', function(e){
$('.menu-slide-section').removeClass("inn");
$('.mobil-menu-item').removeClass('expand');
$('.main-block-nav').removeClass('expandede');
$('.site-nav--has-dropdown').removeClass('openede');
$('.site-nav--has-dropdown').removeClass('current-open');
$('.arrow-dropdown').removeClass('fa-angle-up');
$('.arrow-dropdown').addClass('fa-angle-down');
$('.site-nav__dropdown').css('display','none');
});

$('.template-index .collection-list').not('.slick-initialized').slick({
infinite: true,
slidesToShow: 4,
slidesToScroll: 1,
autoplay: false,
autoplaySpeed: 2000,
arrows: true,
dots: true,
responsive: [
{
breakpoint: 1024,
settings: {
slidesToShow: 3,
}
},
{
breakpoint: 600,
settings: {
slidesToShow:1,
}
}


]
});

$('.other-authors').not('.slick-initialized').slick({
infinite: true,
slidesToShow: 3,
slidesToScroll: 1,
autoplay: false,
autoplaySpeed: 2000,
arrows: true,
dots: true,
responsive: [
{
breakpoint: 1024,
settings: {
slidesToShow: 1,
}
},
{
breakpoint: 600,
settings: {
slidesToShow:1,
}
}


]
});
$('.pro--ads').not('.slick-initialized').slick({
  infinite: true,
       slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  animation: "fade",
  autoplaySpeed: 8000,
  animationLoop:false, 
  arrows: true,
  dots: false,
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow:1,
      }
    }
    
   
  ]
});  
$('.topbanner--ups').not('.slick-initialized').slick({
    infinite: true,
       slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  arrows: false,
  dots: false,
  variableWidth: true,
      responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow:1,
         variableWidth: false,
      }
    }
    
   
  ]
}); 
});


/* pollen table js - 3Aug2020 */

$(document).ready(init);

//$(window).resize(init)


function init(){
if(jQuery(window).width() <= 768){

if(jQuery(window).width() > 640){
var showItems = 6;
var first_row_width = 3;
}else{
var showItems = 3;
var first_row_width = 2;
}


var totalItems = 12;
var maxScroll = 0;

if(jQuery('.pollenTable table').length <= 0){
return false;
}
var contWidth = jQuery('.pollenTable').width();
var th_wid = parseInt(contWidth / first_row_width);


if(jQuery(window).width() > 640){
// for tab
var show_itmsCon = contWidth - th_wid ;
var td_wid = parseInt(show_itmsCon / showItems);
}else{
var td_wid = parseInt(th_wid / showItems);
}




var table_w = parseInt(th_wid + ( td_wid * totalItems ));
var th_height = jQuery('.pollenTable table th:first-child').outerHeight();

jQuery('.pollenTable table th:first-child').outerWidth(th_wid);
jQuery('.pollenTable table tr td').outerWidth(td_wid);
jQuery('.pollenTable table tr td:first-child').outerWidth(th_wid);
jQuery('.pollenTable table ').outerWidth(table_w);

//clone
var cloned =  jQuery('.pollenTable table ').clone().addClass('clonedEl').outerWidth(th_wid);
jQuery('.pollenTable').prepend(cloned)
jQuery(document).find('.pollenTable table.clonedEl th:not(:first-child)').remove();
jQuery(document).find('.pollenTable table.clonedEl tr td:not(:first-child)').remove();
jQuery(document).find('.pollenTable table.clonedEl tr th:first-child').outerHeight(th_height);

// arrow
var lArrow = '<i class="fa fa-angle-left"></i>';
var rArrow = '<i class="fa fa-angle-right"></i>';
jQuery('.pollenTable').prepend('<button class="left">'+ lArrow +'</button><button class="right">'+ rArrow +'</button>');

//  dots
var totalDots = totalItems / showItems;
var dots = '<ul class="navDots">';
  for(i=0;i<totalDots;i++){
  if(i==0){
  dots = dots + '<li class="active" data-index="'+ i * th_wid +'" id="dot_'+ i * th_wid +'" ></li>';
  }else{
  dots = dots + '<li data-index="'+ i * th_wid +'" id="dot_'+ i * th_wid +'" ></li>';
  }
  maxScroll = i * th_wid;
  }
  dots = dots + '</ul>';
jQuery('.pollenTable').append(dots)

//  slide on button click
var leftbtn = jQuery(document).find('.pollenTable button.left');
var rightbtn = jQuery(document).find('.pollenTable button.right');

var scrollStep = th_wid;
var scrollnow = 0;

rightbtn.on('click',function(){

scrollnow = scrollnow + scrollStep;
if(scrollnow >= 0 && scrollnow <= maxScroll){

jQuery('.tableWrap').animate(
{
scrollLeft: scrollnow,
},
500,
'linear'
);
}else{
scrollnow = maxScroll;
}

setDot();


});

leftbtn.on('click',function(){

scrollnow = scrollnow - scrollStep;

if(scrollnow >= 0 && scrollnow <= maxScroll){

jQuery('.tableWrap').animate(
{
scrollLeft: scrollnow,
},
500,
'linear'
);
}else{

scrollnow = 0;

}
setDot();

});

jQuery(document).find('.navDots li').on('click',function(){
var sc = parseInt(jQuery(this).attr('data-index'));
jQuery(this).addClass('active').siblings().removeClass('active');
scrollnow = sc;
jQuery('.tableWrap').animate(
{
scrollLeft: scrollnow,
},
500,
'linear'
);

});


function setDot(){
console.log(scrollnow)
jQuery(document).find('.navDots li#dot_'+scrollnow).addClass('active').siblings().removeClass('active');

}
}
}
/* pollen table js ends - 3Aug2020 */



/* popup css */

$('.login_popup_btn').on('click', function(e) {
e.preventDefault();
$('.modal1').toggleClass('is-visible');
$('ul.login-course li').removeClass('activebtn');
$('.login-poupp form')[0].reset();
$('.register_form form')[0].reset();
$('.forgot-pop form')[0].reset();
$('a.further-btn-popup').css('background-color', '#f7f7f7').removeClass('active');
$('a.further-btn-popup').css('color', '#575757');
$('a.further-btn-popup').removeClass('loginproc');
$('.login-poupp .login_pop_submit').prop('disabled', true).removeClass('activeLogin');
$('.login-poupp input').css("border-color", "#B3B3B3");
$('span.emailerror').hide();
});
$('.login-course li').on('click', function(){
$('.login-course li').removeClass('activebtn');
$(this).addClass('activebtn');
$('a.further-btn-popup').css('background-color', '#A7C610').addClass('active');
$('a.further-btn-popup').css('color', '#fff');
if(!$(this).hasClass('testlink')){
$('a.further-btn-popup').addClass('loginproc');
}else{
$('a.further-btn-popup').removeClass('loginproc');
}
});
$('.login-poupp').on('click', 'a.further-btn-popup', function(e){
if(!$(this).hasClass('active')){
e.preventDefault();
}
});

$('.login-poupp').on('click', 'a.further-btn-popup.loginproc', function(e){
e.preventDefault();
window.location.href = "/account";  
//$('.modal1').toggleClass('is-visible');
//$('.modal2').toggleClass('is-visible');
//$('.login-modal').toggleClass('is-visible');
//$('ul.login-course li').removeClass('activebtn');
//$('.login-poupp form')[0].reset();
//$('.register_form form')[0].reset();
//$('.forgot-pop form')[0].reset();

});
$('.login_popup_btn_form').on('click', function(e) {
e.preventDefault();
$('.modal').removeClass('is-visible');
$('ul.login-course li').removeClass('activebtn');
$('.login-poupp form')[0].reset();
$('.register_form form')[0].reset();
$('.forgot-pop form')[0].reset();
});

$('.creatpop').on('click', function(e) {
e.preventDefault();
$('.modal').removeClass('is-visible');
$('.modal3').toggleClass('is-visible');
$('ul.login-course li').removeClass('activebtn');
$('.login-poupp form')[0].reset();
$('.register_form form')[0].reset();
$('.forgot-pop form')[0].reset();
});

$('.forg_apssw').on('click', function(e) {
e.preventDefault();
$('.modal').removeClass('is-visible');
$('.modal4').toggleClass('is-visible');
$('ul.login-course li').removeClass('activebtn');
$('.login-poupp form')[0].reset();
$('.register_form form')[0].reset();
$('.forgot-pop form')[0].reset();
});

$('.lofinppp').on('click', function(e) {
e.preventDefault();
$('.modal').removeClass('is-visible');
$('.modal2').toggleClass('is-visible');
$('ul.login-course li').removeClass('activebtn');
$('.login-poupp form')[0].reset();
$('.register_form form')[0].reset();
$('.forgot-pop form')[0].reset();
});


// Show the first tab by default
$('.template-customers-account .tabs-stage div').hide();
$('.template-customers-account .tabs-stage div:first').show();
$('.template-customers-account .tabs-nav li:first').addClass('tab-active');

// Change tab class and display content
$('.template-customers-account .tabs-nav a').on('click', function(event){
event.preventDefault();
$('.template-customers-account .tabs-nav li').removeClass('tab-active');
$(this).parent().addClass('tab-active');
$('.template-customers-account .tabs-stage div').hide();
$($(this).attr('href')).show();
});


$('.template-customers-account .tabs-nav li a').on('click', function(){
if($(this).attr('href') == '#tab-2'){
$('.account-bottom-link').removeClass('disnled_link');
}else{
$('.account-bottom-link').addClass('disnled_link');
}
});


$('body').on('click', '.boost-pfs-filter-option-multi-level-list div', function(){
//alert($(this).attr('class'));
$(this).parent('li').addClass('selected');
});

	/*$(document).ready(function(){
  	$("p,h1,h2,h3,h4,li,a,b,span.h4").each(function(){
    	$(this).html($(this).html().replace(/&reg;/gi, '<sup>&reg;</sup>').replace(/®/gi, '<sup>&reg;   </sup>'));
		$(this).html($(this).html().replace('<sup><sup>®   </sup></sup>', '<sup>&reg;</sup>'));
    });
});*/